/*
All the miscellaneous CONSTANTS used in the project.
API keys, hardcoded params, settings can be defined here
*/

export const MAX_LIST_SIZE = 15;
export const API_RATE_LIMIT_ERROR =
  "Rate Limit Error: Don't abuse the API. Please try again after 15 seconds. Please contact support@btcm.group";
